jQuery( ".hamburger" ).click( function() {
	
	
	if( jQuery( '.mobile-nav' ).hasClass( 'open' ) ) {
		
		jQuery(this).removeClass('ng-x');
		
		jQuery('.mobile-nav').removeClass('open');
		
	}
	
	else {
		
		jQuery('.mobile-nav').addClass('open');
		jQuery(this).addClass('ng-x');
		
	}
	
 	
  
});


jQuery( window ).scroll(function(){ 
	
	jQuery('.mobile-nav').removeClass('open');
	jQuery('.hamburger').removeClass('ng-x');
	
});